import { useQuery, useMutation, useQueryClient } from "react-query";
import { getAddressUrl, getAddressesUrl, getCreateAddressUrl, getDeleteAddressUrl } from "../endpoints";
import useAxios from "../../hooks/useAxios";


export const useGetAddress = () => {
    const client = useAxios();
    return useQuery('getAddress', (id) => {
        return client.get(getAddressUrl(id));
    });
}

export const useGetAddresses = () => {
    const client = useAxios();
    return useQuery('getAddresses', () => {
        return client.get(getAddressesUrl());
    });
};

export const useCreateAddress = () => {
    const queryClient = useQueryClient();
    const client = useAxios();
    return useMutation((body) => {
        return client.put(getCreateAddressUrl(), body);
    }, {
        onMutate: async(address) => {
            await queryClient.cancelQueries('getAddresses');
            const previousAddresses = queryClient.getQueryData('getAddresses');
            queryClient.setQueryData('getAddresses', (prev) => {
                return {
                    ...prev,
                    data: [...prev.data, {id: prev.data.length ? prev.data[prev.data.length-1]?.id+1 : 1, ...address}]
                };
            });
            return {previousAddresses}; // to revert in case of error
        },
        onError: (_error, _address, context) => {
            queryClient.setQueryData('getAddresses', context.previousAddresses);
        },
        onSettled: () => {
            queryClient.invalidateQueries('getAddresses');
        }
    });
};

export const useDeleteAddress = () => {
    const queryClient = useQueryClient();
    const client = useAxios();
    return useMutation((id) => {
        return client.delete(getDeleteAddressUrl(id));
    }, {
        onMutate: async (id) => {
            await queryClient.cancelQueries('getAddresses');
            const previousAddresses = queryClient.getQueryData('getAddresses');
            queryClient.setQueryData('getAddresses', (prev) => {
                return {
                    ...prev,
                    data: [...prev.data].filter((address) => address.id !== id)
                };
            });
            return {previousAddresses}; // to revert in case of error
        },
        onError: (_error, _address, context) => {
            queryClient.setQueryData('getAddresses', context.previousAddresses);
        },
        onSettled: () => {
            queryClient.invalidateQueries('getAddresses');
        }
    });
};